import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface GetAccount {
	response: Api.Operations['getAccount']['responses']['200']['content']['application/json']
}

export const getAccount = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<GetAccount>(
		{
			method: 'get',
			url: '/account',
			...overideConfig,
		},
		axiosInstance,
	)
